import {Search} from '@kaman/uikit';

interface SearchBarProps {
    label: string;
    onClick?: () => void;
}

export const SearchBarCmp = ({label, onClick}: SearchBarProps) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className="w-full flex items-center gap-2 rounded-md border bg-gray-50 px-4 py-4 text-sm text-gray-500 h-11"
        >
            <Search size={20} className=" flex-shrink-0" />
            <span className="text-[0.875rem]">
                جستجو در{' '}
                <span className="font-bold text-primary text-[0.875rem]">
                    فروشگاه های {label}
                </span>
            </span>
        </button>
    );
};
